import { renderToString } from 'react-dom/server'

const columns = [
    {
      "data": "name",
      "className": "bold",
      "render": function(data, type, row, meta) {
        return renderToString(<a href={row['url']}>{data}</a>)
      }
    }
]

const headers = [
    'Name',
]

const filters = [
  {
    name: 'Show archived only', customParam: 'show_archived', kind: 'radio', options: [
      { value: 1, label: 'Yes' },
    ]
  }
]

const sorters = [
]

const order = [[ 0, "asc" ]]

export { columns, headers, filters, sorters, order }
